import { render, staticRenderFns } from "./StaffIncrementReportPrint.vue?vue&type=template&id=4faf9e56&scoped=true&"
import script from "./StaffIncrementReportPrint.vue?vue&type=script&lang=js&"
export * from "./StaffIncrementReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./StaffIncrementReportPrint.vue?vue&type=style&index=0&id=4faf9e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf9e56",
  null
  
)

export default component.exports